import { ContentfulEntryType } from './contentful-entry.type';

export class ExerciseType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get flagText(): string {
    return this.fields['flagText'];
  }

  public get answerPrompt(): string {
    return this.fields['answerPrompt'];
  }

  public get problemTypePrompt(): string {
    return this.fields['problemTypePrompt'];
  }

  public get strategyPrompt(): string {
    return this.fields['strategyPrompt'];
  }

  public get hypothesisPrompt(): string {
    return this.fields['hypothesisPrompt'];
  }

}


